import { createRatesService } from './rate.service';

const ENDPOINT = '/api/national_insurance_thresholds';
const NITresholdService = createRatesService(ENDPOINT, 'national_insurance_threshold', 'threshold');

export default NITresholdService;
